import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cotation-contact',
  templateUrl: './cotation-contact.component.html',
  styleUrls: ['./cotation-contact.component.scss']
})
export class CotationContactComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
